import dispatcher from '../others/Dispatcher';

export function updateAuthentication(oauth) {
    dispatcher.dispatch({
        type: 'UPDATE_AUTHENTICATION',
        body: oauth
    });
}
export function updateUsername(username) {
    dispatcher.dispatch({
        type: 'UPDATE_USERNAME',
        body: username
    });
}

export function refresh() {
    dispatcher.dispatch({
        type: 'REFRESH'
    });
}


// WEBPACK FOOTER //
// ./src/js/actions/NavbarActions.js